module.exports = __webpack_public_path__ + "sit/20260420175840/img/url-app.d88da72d.png";